class SyndicationTypes {
	static Normal = 0;
	static SyndicationOrigination = 1;
	static SplitMaster = 2;
}

export default SyndicationTypes;